<template>
    <div class="entProject">
        <div class="head-menu">
            <div class="head-menu-right entProject-head">
                <el-tooltip class="item" effect="dark" :content="pageTitle" placement="top-start">
                    <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
                </el-tooltip>
            </div>
            <div class="head-menu-left">
                <div class="head-menu-item" v-for="item in items" :key="item.id" :class="{'curFirstMenu':item.id==menu.firstMenu.id}" @click="firstMenuFun(item)">
                    <div class="item-box">
                        <p style="width:100%;padding: 5%;">{{item.name}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-main">
            <el-menu class="el-menu-vertical" v-if="secondMenu.length>0">
                <div style="width: 100%;height: 4vh;display: flex;align-content: center;align-items: center;font-weight: bold;">
                    <div style="width:100%;">
                        <span slot="title"> {{ menu.firstMenu.name }}</span>
                    </div>
                </div>
                <template v-for="item in secondMenu">
                    <el-submenu :key="item.id" v-if="item.isChild" :index="item.id">
                        <template slot="title">
                            <i v-if="item.icon == ''" class="el-icon-document"></i>
                            <img v-else :src="item.icon" class="el-icon-other" style="max-width:30px;max-height:30px;margin-right: 10px;" />
                            <span>{{item.name}}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-for="child in item.children" :key="child.id" :index="child.id">
                                <div style="width:100%;text-align: left;" @click="pageMenu(child)">
                                    <i v-if="child.icon == ''" class="el-icon-document"></i>
                                    <img v-else :src="child.icon" class="el-icon-other" style="max-width:30px;max-height:30px;margin-right: 10px;" />
                                    <span slot="title"> {{ child.name }}</span>
                                </div>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item :key="item.id" v-else :index="item.id"  :class="{'sec-menu':item.id==menu.secMenu.id}" style="padding:0;">
                        <div style="width:100%;text-align: left;" @click="pageMenu(item)">
                            <i v-if="item.icon == ''" class="el-icon-document"></i>
                            <img v-else :src="item.icon" class="el-icon-other" style="max-width:30px;max-height:30px;margin-right: 10px;" />
                            <span slot="title"> {{ item.name }}</span>
                        </div>
                    </el-menu-item>
                </template>
            </el-menu>
            <div class="box-main-con">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
export default {
    data(){
        return{
            pageTitle:'',//页面项目名称
            groupId:'',
            items:[  //菜单列表
                {id:'1',name:'劳务统计',isChild:true,children:[
                    {id:'103',name:'班组信息',href:'/teamCom'},
                    {id:'104',name:'人员信息',href:'/workerCom'},
                    {id:'101',name:'班组出勤',href:'/attendTeamCom'},
                    {id:'102',name:'打卡记录',href:'/attendRecordCom'},
                ]},
                {
                    id:'4',name:'项目监控',isChild:false,href:'/monitoringCom'
                }
            ],
            menu:{  
                firstMenu:{id:'1',name:'劳务统计'},//一级菜单
                secMenu:{id:'101',name:'班组出勤'},//二级菜单
            },
        }
    },
    mounted(){
        this.groupId = util.session.get('proId')
        this.getProInfo()
        this.setSeconMenuFun()
    },
    methods:{
        //获取详情
        getProInfo(){
            var that = this
            myHttp.findProjectInfo({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.result||{}
                    that.pageTitle = data.name
                }
            })
        },
        //获取当前页面的菜单
        filterMenu(){
            var menu = util.session.get('proMenu')
            for(var i=0;i<this.items.length;i++){
                if(menu && menu.firstMenu.id == this.items[i].id){
                    this.menu = menu
                }
            }
        },
        //设置二级菜单（初始化）
        setSeconMenuFun(){
            this.filterMenu()
            if(!this.menu){
                this.menu = {firstMenu:{id:this.items[0].id,name:this.items[0].name}}
                if(this.items[0].children>0){
                    this.secondMenu = this.items[0].children
                    this.menu.secMenu = {id:this.items[0].children[0].id}
                }
            }else if(this.menu.secMenu && this.menu.secMenu.id!=''){
                this.secondMenu = util.common.getNameByList(this.menu.firstMenu.id,this.items,'id','children')||[]
            }
            this.isShow = true
        },
        //一级菜单点击方法
        firstMenuFun(obj){
            //console.log(obj.children)
            this.menu.firstMenu = {id:obj.id,name:obj.name}
            if(obj.children && obj.children.length>0){
                this.secondMenu = obj.children
                this.menu.secMenu = obj.children[0]
                if(obj.children[0].target =='_blank'){
                    let routeUrl = this.$router.resolve({
                        path: obj.children[0].href
                    });
                    window.open(routeUrl .href, '_blank');
                }else{
                    this.$router.push({ path: obj.children[0].href })
                }
            }else{
                this.secondMenu = []
                if(obj.target=='_blank'){
                    let routeUrl = this.$router.resolve({
                        path: obj.href
                    });
                    window.open(routeUrl .href, '_blank');
                }else{
                    this.$router.push({ path: obj.href })
                }
            }
            util.session.set('proMenu', this.menu)
            this.isShow = true
        },
        //二级菜单点击方法
        pageMenu(obj){
            this.menu.secMenu = {id:obj.id}
            util.session.set('proMenu', this.menu)
            this.$router.push({ path: obj.href })
        },
        //返回
        goBack(){
            if(util.session.get('backPage')=='4'){
               util.session.remove('proMenu')
                this.$router.replace({ path: '/conproTotal' })
            }
              if(util.session.get('backPage')=='3'){
                util.session.remove('proMenu')
                this.$router.replace({ path: '/entProAttend' })
            }
        },
    }
}
</script>
<style scoped>
    .entProject{
        width: 100%;
        height: 100vh;
        position: relative;
    }
    .head-menu{
        width: 100%;
        height: 5vh;
        position: relative;
        display: flex;
        background: #358ADA;
    }
    .head-menu-right{
        width: 20vw;
        height: 100%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 0 1vw;
        color: #fff;
    }
    .head-menu-left{
        flex: 1;
        height: 100%;
        position: relative;
        display: flex;
        /* justify-content: center;
        justify-items: center; */
        padding: 0 1vw;
    }
    .head-menu-item{
        width: 8%;
        height: 100%;
        position: relative;
        /* padding: 0.5% 1%; */
    }
    .item-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        cursor: pointer;
        color: #fff;
    }
    .item-box:hover,.curFirstMenu .item-box{
        background: #2566C0;
    }
    .el-menu-vertical{
        width: 7.8vw;
        min-height: 37vh;
    }
    .box-main{
        width: 100%;
        height: 95vh;
        position: relative;
        display: flex;
    }
    .box-main-con{
        flex: 1;
        height: 100%;
        position: relative;
        background: #ecf0f5;
    }
    .toSmall{
        width: 96.27vw;
    }
    .toAll{
        width: 99.6vw;
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 10vw;
        min-height: 400px;
        
    }
    .el-menu-item{
        display: flex;
        align-items: center;
        align-content: center;
    }
    .el-menu--collapse{
        width: 3.33vw;
    }
</style>
<style>
    .entProject-head .el-page-header{
        display: flex;
        align-items: center;
        width: 100%;
    }
    .entProject-head .el-page-header__content{
        color: #fff;
    }
    .entProject-head .el-page-header__content{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 5vh;
    }
    .entProject-head .el-page-header__left {
        display: flex;
        width: 5vw;
    }
    @import '../../assets/css/common.css';
</style>